<template>
  <div class="flex flex-col gap-[32px] w-full">
    <!-- Hero Section with Icon and Title -->
    <div class="flex flex-col items-center">
      <!-- Animation Logo -->
      <div class="w-full md:max-w-md md:mx-auto px-[8px]">
        <img
          src="/assets/images/my-giving/mygiving_home_animation.webp"
          class="w-full h-auto object-contain"
          alt="MyGiving Animation"
        />
      </div>
      <!-- Title and Subtitle -->
      <div class="flex flex-col gap-[24px]">
        <div
          class="text-[#21201E] text-center font-[400] text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.25rem] lg:leading-[2.5rem]"
        >
          Giving grows our hearts for God and others. As we give, we build a Home for others to
          encounter God.
        </div>
        <BibleVerse />
        <div class="flex flex-col gap-[12px] w-full">
          <GiveNowButton />
          <!--TODO replace href-->
          <div
            class="w-full md:max-w-sm md:mx-auto rounded-[100px] border-[2px] border-[#42362B] text-[1rem] md:text-[1.25rem] lg:text-[1.375rem] leading-[1.5rem] md:leading-[1.75rem] lg:leading-[2rem] font-bold text-[#21201E] px-[16px] md:px-[20px] lg:px-[24px] py-[12px] md:py-[14px] lg:py-[16px] text-center cursor-pointer"
            @click="gotoManage()"
          >
            Manage My Giving
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GiveNowButton from '../Common/GiveNowButton.vue';
import BibleVerse from '@/components/MyGiving/LandingPage/BibleVerse.vue';
export default {
  components: { GiveNowButton, BibleVerse },
  methods: {
    gotoManage() {
      this.$router.push('/my-giving/manage');
    },
  },
};
</script>
<style scoped>
* {
  font-family: 'Inter';
}
</style>
